
import React from 'react'
import ReactPlayer from 'react-player/youtube'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Card from '@taglivros/oef_componentes/build/components/card'
import { bool, func, string } from 'prop-types'

const Titulo = styled.h2`
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 5px;

  @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
      font-size: 18px;
    }
`

const Subtitulo = styled.p`
  font-size: 14px;
  margin: 0;
  margin-bottom: 15px;
`

const Video = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 85%;

  @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    max-width: 100%;
  }
`

const CardVideo = ( {
  subtitulo,
  playAutomatico,
  onIniciar,
  onFinalizar,
  titulo,
  urlVideo,
} ) => {
  const { isMobile } = StyleGuide

  return (
    <Card
      padding={ isMobile() ? '20px' :'30px' }
    >
      <Titulo>
        { titulo }
      </Titulo>

      <Subtitulo>
        { subtitulo }
      </Subtitulo>

      <Video>
        <ReactPlayer
          controls={ true }
          height={ isMobile() ? '210px' : '382px' }
          onEnded={ onFinalizar }
          onStart={ onIniciar }
          playing={ playAutomatico }
          url={ urlVideo }
          width={ isMobile() ? '276px' : '100%' }
        />
      </Video>
    </Card>
  )
}

CardVideo.propTypes = {
  'onFinalizar': func,
  'onIniciar': func,
  'playAutomatico': bool,
  'subtitulo': string,
  'titulo': string,
  'urlVideo': string.isRequired,
}

CardVideo.defaultProps = {
  'onFinalizar': () => {},
  'onIniciar': () => {},
  'playAutomatico': false,
  'subtitulo': '',
  'titulo': '',
}

export default CardVideo

